export const getDescriptionId = (fieldId: string) => `${fieldId}__description`

export const getErrorListId = (fieldId: string) => `${fieldId}__errors`
